import { Divider } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CollapsiblePanel } from 'src/components/CollapsiblePanel';
import { onlyValidChildren } from 'src/lib/react';

import { useStyles } from './useStyles';

export const BlockCollapse = ({
  children,
  className,
  classes,
  showCollapse,
  panelClasses,
  title,
  titleModified,
  hideTopDivider,
  hideBottomDivider,
  expanded,
  onToggle,
}) => {
  const styles = useStyles({ classes });

  // Do not render anything if there are no valid children to render
  if (onlyValidChildren(children).length === 0) {
    return null;
  }

  // If we are not supposed to show the collapse, just render the children
  if (!showCollapse) {
    return children;
  }

  // If no expanded state or onToggle is provided, render children without collapse functionality
  if (expanded === undefined || onToggle === undefined) {
    return (
      <div className={cx(styles.root, className)}>
        {!hideTopDivider && <Divider className={styles.dividerWide} />}
        {children}
        {!hideBottomDivider && <Divider className={styles.dividerWide} />}
      </div>
    );
  }

  // Otherwise, render children wrapped into "collapse" block
  return (
    <div className={cx(styles.root, className)}>
      {!hideTopDivider && <Divider className={styles.dividerWide} />}

      <CollapsiblePanel
        className={className}
        classes={panelClasses}
        title={title}
        titleModified={titleModified}
        expanded={expanded}
        onToggle={onToggle}
      >
        {children}
      </CollapsiblePanel>

      {!hideBottomDivider && <Divider className={styles.dividerWide} />}
    </div>
  );
};

BlockCollapse.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  showCollapse: PropTypes.bool,
  panelClasses: PropTypes.shape({}),
  title: PropTypes.string,
  titleModified: PropTypes.bool,
  hideTopDivider: PropTypes.bool,
  hideBottomDivider: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
};

BlockCollapse.defaultProps = {
  children: null,
  className: null,
  classes: null,
  showCollapse: true,
  panelClasses: null,
  title: '',
  titleModified: false,
  hideTopDivider: false,
  hideBottomDivider: false,
  expanded: undefined,
  onToggle: undefined,
};
